// 运维升级http=》https
const prefix = 'https://cjmgwpz.jgwcjm.com/apiInterface/interface';
//超级码云域名
let cjmyName = 'https://packaging.jgwcjm.com/apiInterface/interface';
// 区块链域名
let qkName = 'https://login.jgwcjm.com/apiInterface/interface';
module.exports = {
  common: {
    //
    requestPrefix: prefix,
    //展示图片
    fileDomain: 'https://file.jgwcjm.com',
    // 展示视频
    showVideo: 'https://cjm3v.jgwcjm.com',
    //获取功能定制列表数据
    getDynamicDataList: `${prefix}/trace/dynamic/fun/list/noToken`,
    // 真伪查询
    checkout: '/fake/record/search/api/fake-search',
    // 真伪查询---查询记录
    checkRecord: '/fake/record/search/api/fake-search-details',

    //页面访问量统计
    statistics: {
      //新增/设置
      save: `${prefix}/hydra-data-point/api/v1/data-point/add`,
      //获取
      get: `${prefix}/hydra-data-point/api/v1/data-point/get`,
      // 超级码云登录
      clound_login: `/apiInterface/interface/hydra-user/api/v1/user/web/login`,
      // 超级码云获取sysId
      clound_sysUrl: `/apiInterface/interface/hydra-user/api/v1/sys/sys/url`,
      // 超级码云绑定组织
      clound_orgList: `/apiInterface/interface/hydra-user/api/v1/org/sys/filter-user`,
      // 区块登录
      qk_login: `/apiInterface/interface/hydra-user/api/v1/user/web/login`,
      // 区块链获取sysId
      sysUrl: `/apiInterface/interface/hydra-user/api/v1/sys/sys/url`,
      // 区块绑定组织
      orgList: `/apiInterface/interface/hydra-user/api/v1/org/sys/filter-user`,
      test: '/apiInterface/interface/hydra-user/api/v1/org/sys/filter-user',
    },
  },
};
